<template>
  <v-app>
    <v-row>
      <v-navigation-drawer
        v-model="drawer"
        :permanent="isDesktop"
        :temporary="!isDesktop"
        v-if="question && (isDesktop || drawer)"
        :fixed="!isDesktop"
        style="height: 100vh; overflow-y: auto; z-index: 100;"
      >
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title mb-2" :class="!isDesktop ? 'mt-9' : ''">Replay</v-list-item-title>
              <v-list-item class="mb-4">
                <v-btn outlined color="indigo" @click="voicePlay()">
                  <v-icon dark left> mdi-play </v-icon> play
                </v-btn>
              </v-list-item>
              <v-list-item-title class="title mb-2"
                >フィルター</v-list-item-title
              >
              <v-list-item-title>文字列検索(完全一致)</v-list-item-title>
              <v-list-item>
                <v-text-field
                  label="検索"
                  placeholder="例) yuno"
                  v-model="search_text"
                  id="input_search"
                ></v-text-field>
              </v-list-item>
              <v-list-item-title>作品</v-list-item-title>
              <v-list-item class="pb-16">
                <v-list class="overflow-y-auto" dense style="right: 200px">
                  <v-list-item @click="() => (filter_title = undefined)">
                    <v-list-item-title>
                      全ての作品
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-for="(title, index) in title_list"
                    :key="index"
                    @click="
                      filter_title = title.m_TitleType;
                      drawer = false;
                    "
                  >
                    <v-list-item-title>{{
                      title.m_DisplayName
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-list-item>
            </v-list-item-content>
          </v-list-item>
          <!-- 必要に応じてメニュー項目を追加 -->
        </v-list>
      </v-navigation-drawer>
      <v-col class="mt-2 pt-0" style="height: 100vh; overflow-y: auto;">
        <v-row
          class="px-1"
          style="position: sticky; top: 0; z-index: 10; background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.04);"
        >
          <v-col cols="4" align="right">
            <v-btn outlined color="indigo" @click="voicePlay()">
              <v-icon dark left> mdi-play </v-icon> play
            </v-btn>
          </v-col>
          <v-col class="text-center px-1" align="center">
            残り{{ remainTime }} 秒 <br />
            {{ answered_count }} / {{ max_quiz }} 問目
          </v-col>
          <v-col
            v-if="question === false && answered_count <= 4"
            cols="4"
            align="left"
          >
            <v-btn outlined color="indigo" @click="() => makeQuiz()">
              次の問題
            </v-btn>
          </v-col>
          <v-col v-if="question && !isDesktop" align="left">
            <v-btn
              outlined
              color="indigo"
              @click="() => (this.drawer = !this.drawer)"
            >
              <v-icon dark left> mdi-filter </v-icon> Filter
            </v-btn>
          </v-col>

          <v-col
            v-else-if="question === false && answered_count >= 5"
            align="left"
          >
            <v-btn outlined color="indigo" @click="() => jumpResultPage()">
              リザルトへ
            </v-btn>
          </v-col>
        </v-row>

        <v-col v-if="question" style="height: 400px" class="mt-5">
          <v-card style="padding-bottom: 120px;">
            <v-list>
              <v-list-item-group v-model="selected">
                <v-list-item @click="() => click('pass')">
                  <v-list-item-content>
                    <v-list-item-title>この問題をパス</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-for="(item, i) in searched_list"
                  :key="i"
                  @click="() => click(item)"
                  :color="item.color"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.m_FullName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <!-- </span> -->
        <v-col style="text-align: center;" class="mt-5" v-else>
          <span class="text-h5">
            <p class="font-weight-regular">
              {{ text }}
            </p>
            <span class="text-body-1"> 答えは </span>
            <span class="font-weight-regular">
              {{ remainQuestionable[correct].m_FullName }}
            </span>

            <br />
            <img
              :src="getCharaImageUrl(remainQuestionable[correct])"
              v-if="!show_result_img"
              class="mt-2"
              style="width: min(100%, 600px)"
            />
          </span>
        </v-col>
      </v-col>
    </v-row>
    <span
      class="quiz_img"
      v-if="img_correct"
      text-align="center"
      style="z-index: 999999;"
    >
      <v-img :src="require('../assets/correct.svg')"></v-img>
    </span>
    <span
      class="quiz_img"
      v-if="img_wrong"
      text-align="center"
      style="z-index: 999999;"
    >
      <v-img :src="require('../assets/wrong.svg')"></v-img>
    </span>
  </v-app>
</template>

<style>
.quiz_img {
  width: calc(100vmin - 60px);
  position: fixed;
  top: calc(50% - (100vmin - 60px) / 2 + 20px);
  left: calc(50% - (100vmin - 60px) / 2);
}
/* .fab-container {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-right: -100px;
} */
</style>

<script>
export default {
  props: ["returnStartPageThis"],
  data() {
    return {
      drawer: this.$vuetify ? this.$vuetify.breakpoint.mdAndUp : true,
      selected: undefined,
      correct: undefined,
      questionList: [],
      question: true,
      text: "",
      remainQuestionable: [],
      title_list: [],
      filter_title: undefined,
      search_text: "",
      remainTime: 180,
      interval_id: 0,
      result: [
        // { m_DisplayName: "yuno", "m_ResouceBaseName: "ゆの", correct: boolean },
      ],
      max_quiz: 5,
      img_correct: false,
      img_wrong: false,
      img_interval_id: 0,
    };
  },

  computed: {
    searched_list() {
      const str = this.search_text;
      const searchRegexp = new RegExp(str, "i");
      const match = (x) => searchRegexp.test(x);
      return this.returnStartPageThis.db
        .filter(
          (element) =>
            match(element.m_NickName) ||
            match(element.m_FullName) ||
            match(element.m_ResouceBaseName) ||
            match(element.m_CVText) ||
            match(element.fullName)
        )
        .filter((chara) => {
          if (this.filter_title === undefined) {
            return true;
          } else {
            return this.filter_title === chara.m_TitleType;
          }
        });
    },
    chara() {
      return this.remainQuestionable[this.correct];
    },
    isDesktop() {
      return this.$vuetify && this.$vuetify.breakpoint.smAndUp;
    },
    answered_count() {
      return this.result.length + 1 - (!this.question ? 1 : 0);
    },
    show_result_img() {
      return this.img_correct || this.img_wrong;
    },
  },
  methods: {
    search_reset() {
      window.vue = this;
      this.search_text = "";
      this.filter_title = undefined;

      // const input_elm = document.getElementById("input_search")
      // if(input_elm){
      //   input_elm.value = null;
      // }
    },
    click(item) {
      const dispTime = 1200;
      scrollTo(0, 0);
      clearInterval(this.interval_id);
      if (item === "pass") {
        this.text = "";
        wrong.bind(this)(item, "パス");
      } else if (item === "timeover") {
        this.drawer = false;
        this.text = "時間切れ！";
        wrong.bind(this)(item, "時間切れ");
      } else if (
        item.m_NamedType === this.remainQuestionable[this.correct].m_NamedType
      ) {
        // this.$set(item, "color", "blue");
        this.text = "正解！";
        this.img_correct = true;
        setTimeout(() => (this.img_correct = false), dispTime);
        this.result.push({
          i: this.result.length + 1,
          m_FullName: this.chara.m_FullName,
          primaryCharacterID: this.chara.primaryCharacterID,
          correct: true,
          answer: this.chara.m_FullName,
        });
      } else {
        // this.$set(item, "color", "red");
        this.text = "不正解...";
        wrong.bind(this)(item, item.m_FullName);
      }

      this.question = false;
      console.log("object :>> ", this.question);

      function wrong(_item, answer) {
        this.img_wrong = true;
        setTimeout(() => (this.img_wrong = false), dispTime);
        this.result.push({
          i: this.result.length + 1,
          m_FullName: this.chara.m_FullName,
          primaryCharacterID: this.chara.primaryCharacterID,
          m_ResouceBaseName: this.chara.m_ResouceBaseName,
          correct: false,
          answer,
        });
      }
    },
    random(length) {
      return Math.floor(Math.random() * length);
    },

    setCountdown() {
      this.interval_id = setInterval(() => {
        if (this.remainTime === 1) {
          clearInterval(this.interval_id);
          this.click("timeover");
        }
        this.remainTime--;
      }, 1000);
    },
    jumpResultPage() {
      console.log("this.result :>> ", this.result);
      this.returnStartPageThis.result = this.result;
      this.returnStartPageThis.mode = this.returnStartPageThis.modeList.results;
    },
    voicePlay() {
      this.returnStartPageThis.play(
        this.remainQuestionable[this.correct]["m_ResouceBaseName"]
      );
    },
    makeQuiz() {
      // console.log(this.returnStartPageThis.db);
      if (this.correct !== undefined) {
        // console.log(this.remainQuestionable);

        this.remainQuestionable.splice(this.correct, 1);
        // console.log(this.remainQuestionable);
      }
      // this.remainQuestionable = Array.from(this.returnStartPageThis.db);
      // let homeVM = this.returnStartPageThis;
      // console.log(homeVM.remainQuestionable);

      let ramdom = this.random(this.remainQuestionable.length);

      this.correct = ramdom;

      this.selected = undefined;
      // this.questionList = homeVM.db;
      this.search_reset();
      this.question = true;
      this.remainTime = 120;
      this.drawer = false;
      this.setCountdown();
      this.voicePlay();
      this.preloadImage(
        this.getCharaImageUrl(this.remainQuestionable[this.correct])
      );
      this.preloadImage(
        this.getCharaIconUrl(this.remainQuestionable[this.correct])
      );
    },
    getCharaImageUrl(chara) {
      return `https://asset.kirafan.cn/texture/charauiresource/characard/characard_${chara.primaryCharacterID}.png`;
    },
    getCharaIconUrl(chara) {
      return `https://mergedcharaicon-asset.kirafan.cn/charaicon_${chara.primaryCharacterID}.png`;
    },
    preloadImage(url) {
      const img = new Image();
      img.src = url;
    },
    init() {
      this.remainQuestionable = Array.from(this.returnStartPageThis.db);
      this.title_list = this.returnStartPageThis.returnHomeThis.title_list;
      this.result = [];
      this.max_quiz = 5;

      // console.log(this.title_list);
      this.makeQuiz();
    },
  },

  mounted() {
    this.init();
    window.vue = this;
    // homeVM.remainQuestionable[this.correct];
    // homeVM.remainQuestionable.splice(ramdom, 1);
    // for (let i = 0; i < 4; i++) {
    //   let random = this.random(homeVM.remainQuestionable.length);
    //   let ramdom_get = homeVM.remainQuestionable[random];
    //   ramdom_get.color = this.correct === i ? "blue" : "red";
    //   this.questionList.push(ramdom_get);
    //   homeVM.remainQuestionable.splice(random, 1);
    // }
    // console.log(this.questionList,homeVM.remainQuestionable);
  },
  watch: {
    isDesktop(val) {
      this.drawer = val;
    },
  },
};
</script>
